// utils
import { buildTestId } from '@/utils/helpers.utils';
import { getFareFamiliesBaggageContent } from '@/utils/content.utils';

// hooks
import { useTranslation } from 'react-i18next';

// style
import { CircleIcons } from '@tajawal/ct-web-design-system';
import RuleItem from '@/app-common/components/RuleItem/RuleItem';

// Components
import { BaggageInfoTitle } from '@/app-common/components/BaggageInfoBox/components/BaggageInfoTitle/BaggageInfoTitle';

export type BaggageItemProps = {
  baggageInfo: any;
  isChecked?: boolean;
  testIdPrefix: string;
  isUnderSeatBaggage?: boolean;
  isWhiteIcon?: boolean;
};

function BaggageItem({
  baggageInfo,
  isChecked,
  testIdPrefix,
  isUnderSeatBaggage = false,
  isWhiteIcon = false,
}: BaggageItemProps): JSX.Element {
  const { t } = useTranslation();
  const { isIncluded, weight, dimensions } = baggageInfo || {};
  const testId = buildTestId(testIdPrefix, 'Baggage', isChecked ? 'Checked' : 'Cabin');

  const baggageContent = getFareFamiliesBaggageContent({
    isIncluded,
    weight,
    isChecked,
    t,
    dimensions,
    isUnderSeatBaggage,
  });

  return (
    <RuleItem
      icon={isIncluded ? <CircleIcons.Check width="24" height="24" /> : <CircleIcons.Close width="24" height="24" />}
      message={
        <BaggageInfoTitle
          baggageText={baggageContent}
          isUnderSeatBaggage={isUnderSeatBaggage}
          isIncluded={isIncluded}
        />
      }
      testIdPrefix={testId}
      isWhiteIcon={isWhiteIcon}
    />
  );
}

export default BaggageItem;
